export default "__VITE_ASSET__4ieo2cUc__"